export default __webpack_public_path__ + "701940b41f54e705cc94e95b4486246a.jpg";